// /src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
// Optionally, analytics (for dev, not required in production)
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBufBz43HWEH_GE-9xdOQPxxi-7l4F0mHc",
  authDomain: "doctorscout-f11db.firebaseapp.com",
  databaseURL: "https://doctorscout-f11db-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "doctorscout-f11db",
  storageBucket: "doctorscout-f11db.appspot.com",
  messagingSenderId: "362022646828",
  appId: "1:362022646828:web:776354026c4ade9dba8d89",
  measurementId: "G-H57DQTY1GB"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);               // <-- For Authentication
export const db = getDatabase(app);             // <-- For Realtime Database

// Analytics (optional, not needed for calendar/app logic)
export const analytics = getAnalytics(app);
export { app };
